
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.9 86.2L41 51.5v-9.7H8.8v10h20.3L8.2 86.2zM59.3 86.2l21.1-34.7v-9.7H48.2v10h20.3L47.6 86.2zM98.7 86.2l21.1-34.7v-9.7H87.6v10h20.3L87 86.2zM24.6 8.3C10.5 8.3 0 8.3 0 31.3h10c0-11.5 2.4-13 14.6-13s14.6 1.5 14.6 13h10c0-23.3-10.4-23-24.6-23zM103.4 8.3c-14.1 0-24.6 0-24.6 23h10c0-11.5 2.4-13 14.6-13s14.6 1.5 14.6 13h10c0-23.3-10.4-23-24.6-23z"}}),_c('path',{attrs:{"d":"M64 8.3c-14.1 0-24.6 0-24.6 23h10c0-11.5 2.4-13 14.6-13s14.6 1.5 14.6 13h10c0-23.3-10.4-23-24.6-23zM103.4 118.7c14.1 0 24.6 0 24.6-23h-10c0 11.5-2.4 13-14.6 13s-14.6-1.5-14.6-13h-10c0 23.3 10.4 23 24.6 23zM24.6 118.7c14.1 0 24.6 0 24.6-23h-10c0 11.5-2.4 13-14.6 13S10 107.2 10 95.7H0c0 23.3 10.4 23 24.6 23z"}}),_c('path',{attrs:{"d":"M64 118.7c14.1 0 24.6 0 24.6-23h-10c0 11.5-2.4 13-14.6 13s-14.6-1.5-14.6-13h-10c0 23.3 10.4 23 24.6 23z"}})])
          )
        }
      }
    